import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import api from './api';
import bugsnagMiddleware from './bugsnagMiddleware';
import rootReducer from './reducers';

const devMode = process.env.NODE_ENV === 'development';

export default function configureStore(initialState) {
    const middlewares = [thunk.withExtraArgument(api), bugsnagMiddleware];

    if (devMode) {
        middlewares.push(logger);
    }

    const store = createStore(
        rootReducer,
        initialState,
        applyMiddleware(...middlewares)
    );

    return store;
}



// WEBPACK FOOTER //
// ./src/redux/store.js